document.addEventListener('alpine:init', () => {
  Alpine.data('pastWalksCarousel', (total) => ({
    current: 0,
    total,
    perPage: 3,

    init() {
      this.updatePerPage();
      window.addEventListener('resize', () => this.updatePerPage());
    },

    updatePerPage() {
      this.perPage = window.innerWidth < 768 ? 1 : window.innerWidth < 1024 ? 2 : 3;
      if (this.current > this.maxIndex) this.current = this.maxIndex;
    },

    get maxIndex() {
      return Math.max(0, this.total - this.perPage);
    },

    next() {
      if (this.current < this.maxIndex) this.current++;
    },

    prev() {
      if (this.current > 0) this.current--;
    },
  }));
});
